import { Http, Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from "app/auth/auth.service";
import { JwtToken } from "app/shared/services/portal-info";
import { Resolve } from "@angular/router";
import { EmiDataService } from "app/emi-data.service";
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';

// Used previous to PortalLaodingResolverService; Doubt on current usage.
@Injectable()
export class EmiBasicResolverService implements Resolve<any> {
    constructor(
      private authService:AuthService,      
    ) { 
    }

    resolve(
    ){
      console.log('EmiBasicResolverService - Start');
      return this.authService.getJwtToken()
        .map(response => {
          var JwtToken =  response.json().token;
          localStorage.setItem('id_token',JwtToken);
          return response.json()
        });
    }
}

// To collect jwt token and basic portal data before portal loads
@Injectable()
export class PortalLaodingResolverService implements Resolve<any> {
    constructor(
      private authService:AuthService,
      private emiDataService:EmiDataService,
    ) { }

    resolve():Observable<any> {
      console.log('PortalLaodingResolverService - Start');
      return this.authService.getJwtToken()
      .map(res => res.json())
      .switchMap(JwtToken => {
        localStorage.setItem('id_token',JwtToken.token);
        return this.emiDataService.getBasicLoadingDatas();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/emi-basic-resolver.service.ts